<template>
  <div class="page">
    <div style="display: flex;">
      <div style="height: 40px;line-height: 40px;">
        <label style="margin-right: 18px;color: orangered;">服务商</label>
        <el-select v-model="branchCode" filterable clearable placeholder="全部" class="yellow-input" style="margin-right: 18px;">
          <el-option v-for="(item,i) in branchlist" :key="i" :label="item.branchName" :value="item.branchCode">
          </el-option>
        </el-select>
      </div>
      <el-tabs v-model="activeName" style="flex: 1;">
        <el-tab-pane label="通知公告" name="first"></el-tab-pane>
        <!-- <el-tab-pane label="报价更新" name="second"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div v-show="activeName == 'first'" style="flex: 1;background-color: #f2f2f2;padding: 20px;display: flex;overflow: hidden;">
      <div style="width: 250px;height: 100%;display: flex;flex-direction: column;">
        <el-input size='medium' placeholder="搜索" prefix-icon="el-icon-search" v-model="search" style="margin-bottom: 20px;"></el-input>
        <div style="flex: 1;overflow: auto;" v-if="noticeformelist.length">
          <div class="preview" v-for="item in noticeformelist" :key="item.noticeId" @click="activenoticeforme = item" :class="{active:activenoticeforme == item}">
            <div>{{item.noticeTitle}}</div>
            <div class="previewtext">{{item.publisherName}} {{item.publishTime}}</div>
          </div>
        </div>
        <div v-else style="text-align: center;color: gray;">暂无内容</div>
      </div>
      <div style="flex: 1;margin-left: 20px;overflow: auto;">
        <div v-if="activenoticeforme" style="min-width: 1200px;padding: 20px;background-color: #fff;box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);">
          <div style="border-bottom: 1px solid #f2f2f2;line-height: 36px;height: 36px;margin-bottom: 20px;">
            <el-image class="container" :src="require('@/assets/img/icon_ar.png')" fit="contain" style="width: 36px;height: 36px;vertical-align: top;" />
            <span style="font-size: 18px;font-weight: bold;margin-left: 15px;">{{activenoticeforme.noticeTitle}}</span>
            <span style="font-size: 12px;float: right;margin-left: 15px;">{{activenoticeforme.publishTime}}</span>
            <span style="font-size: 12px;float: right;margin-left: 15px;">{{activenoticeforme.publisherName}}</span>
          </div>
          <template v-if="activenoticeforme.attachment">
            <div style="height: 48px;line-height: 48px;color: gray;">附件列表:</div>
            <el-table :data="JSON.parse(activenoticeforme.attachment)" @row-click='downloadAttachment' :show-header='false' style="margin-bottom: 18px;font-weight: bold;color: blue;font-size:18px !important">
              <el-table-column width="50">
                <template><i class="el-icon-paperclip" style="font-size:40px !important;"></i></template>
              </el-table-column>
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="size">
                <template slot-scope="{row}">
                  <span>{{row.size/1024/1024>1?(row.size/1024/1024).toFixed(2)+'M':row.size/1024>1?(row.size/1024).toFixed(2)+'KB':'小于1KB'}}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div v-html="activenoticeforme.noticeContent"></div>
        </div>
        <div v-else style="text-align: center;color: gray;">暂无内容</div>
      </div>
    </div>
    <div v-show="activeName == 'second'" style="flex: 1;display: flex;overflow: hidden;">
      <el-table-auto :ref="ref" id='space' name='报价' :isCheck='false' :isPage='false' :column='tableConf' :table-hand='getTable' style="flex: 1;display: flex;flex-direction: column;overflow: hidden;">
        <template #providerQuoteStatus="{row}">
          {{row.providerQuoteStatus?'启用':'停用'}}
        </template>
      </el-table-auto>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { page } from '@/mixins/page'
export default {
	mixins: [page],
	data() {
		return {
			ref: 'space',
			// main
			branchCode: '',
			activeName: 'first',
			// page1
			search: '',
			noticeformelist: [],
			activenoticeforme: '',
			// page2
			tableConf: [
				{ prop: 'providerName', label: '服务商', width: 90 },
				{ prop: 'bizType', label: '业务类型', width: 160 },
				{ prop: 'providerQuoteName', label: '报价名', width: 260 },
				{ template: 'providerQuoteStatus', label: '状态', width: 260 },
				{ prop: 'normalPickupDays', label: '渠道时效', width: 260 },
				{ prop: 'lastUpdateTime', label: '更新时间', width: 160 },
				{ prop: 'lastUpdateContent', label: '更新内容' },
			],
		}
	},
	async mounted() {
		await this.getData()
		this.activenoticeforme = this.noticeformelist.length ? this.noticeformelist[0] : ''
		this.activenoticeforme = this.$route.params.notice ? this.noticeformelist.find((item) => item.noticeId == this.$route.params.notice) : this.activenoticeforme
	},
	watch: {
		branchCode() {
			this.getData()
		},
		search() {
			this.getData()
		},
	},
	methods: {
		async getData() {
			await this.getnoticeformelist()
		},
		// 获取对应服务商或全部公告
		async getnoticeformelist() {
			let params = { pageNum: 1, pageSize: 100 }
			let res = await this.$api.noticeformelist(params)
			this.noticeformelist = this.branchCode ? res.list.filter((item) => item.tenantId == this.branchCode) : res.list
			if (this.search) {
				this.noticeformelist = this.noticeformelist.filter((item) => item.noticeTitle.indexOf(this.search) > -1)
			}
		},
		// 下载文件
		async downloadAttachment(row) {
			this.$notify.info('请稍后')
			Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期
			const a = document.createElement('a')
			a.setAttribute('download', row.name)
			a.setAttribute('href', this.$qiniu.domain + row.url)
			a.click()
			// fetch(this.$qiniu.domain + row.url)
			// 	.then((res) => res.blob())
			// 	.then((blob) => {
			// 		const link = document.createElement('a')
			// 		link.setAttribute('download', row.name)
			// 		link.setAttribute('href', URL.createObjectURL(blob))
			// 		link.click()
			// 	})
		},
		// 获取对应服务商或全部报价
		async getTable() {
			let list = await this.$api.quoteformelist()
			list = this.branchCode ? list.filter((item) => item.tenantId == this.branchCode) : list
			return { list, total: list.length }
		},
	},
}
</script>

<style scoped>
.preview {
	padding: 10px;
	color: #0066ff;
}
.preview + .preview {
	border-top: 1px solid white;
}
.preview.active,
.preview:hover {
	background-color: #ffffff61;
}
.previewtext {
	color: #949494;
	font-size: 10px;
	margin-top: 8px;
}
</style>
